import Icon from '../components/Icon.vue'

Icon.register({"gift":{"width":512,"height":512,"paths":[{"d":"M32 448C32 465.7 46.3 480 64 480H224V320H32V448zM480 160H437.9C444.1 147.9 448 134.5 448 120 448 71.5 408.5 32 360 32 318.4 32 291.5 53.3 257 100.3 222.5 53.3 195.6 32 154 32 105.5 32 66 71.5 66 120 66 134.5 69.8 147.9 76.1 160H32C14.3 160 0 174.3 0 192V272C0 280.8 7.2 288 16 288H496C504.8 288 512 280.8 512 272V192C512 174.3 497.7 160 480 160zM153.9 160C131.8 160 113.9 142.1 113.9 120S131.8 80 153.9 80C173.8 80 188.5 83.3 240 160H153.9zM360 160H273.9C325.3 83.5 339.6 80 360 80 382.1 80 400 97.9 400 120S382.1 160 360 160zM288 480H448C465.7 480 480 465.7 480 448V320H288V480z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/gift.js
// module id = null
// module chunks = 